<template lang="">
  <div class="mains">
    <div class="container">
      <div class="header_title">溯源码库</div>
      <div class="top">
        <div class="select">
          <Input v-model="selectVal" search placeholder="输入流水号" />
        </div>
      </div>
      <div class="main mains">
        <el-empty description="没有数据哦！" v-if="pageData.length==0"/>
        <Table border :columns="columns" :data="pageData" style="width: 100%" v-if="pageData.length!==0">
          <template #name="{ row }">
            <strong>{{ row.name }}</strong>
          </template>

          <template #stat="{ row, index }">
            <span v-if="row.state==0" style="color:red;">未启用</span>
            <span v-if="row.state==1" style="color:green;">已启用</span>
            <span v-if="row.state == 2" style="color: blue">待生码</span>
          </template>
        </Table>
        <!-- 分页 -->
        <Page
          class="page"
          :modelValue="pages"
          :total="allPage"
          simple
          @on-change="page"
        />
      </div>

      <Drawer title="修改企业资料" :closable="false" v-model="value">
        <p>企业代码</p>
        <p>企业名称</p>
        <p>正品回复语</p>
        <p>重复回复语</p>
        <p>多次回复语</p>
      </Drawer>
      <Drawer title="生码" :closable="false" v-model="addVal" width="600">
        <NewCode></NewCode>
      </Drawer>
    </div>
  </div>
</template>
<script>
import NewCode from "@/views/RowCode/NewCode";
import { GetCodeList, getBatchCodes, getBatchCodefiles } from "@/api/index";
import axios from "axios";
export default {
  data() {
    return {
      selectVal: "",
      value: false,
      addVal: false,
      columns: [
        {
          title: "批号",
          key: "batch",
          width: 100,
        },
        {
          title: "企业代码",
          key: "clientcode",
          width: 100,
        },
        {
          title: "开始物流码",
          key: "startSerial",
          width: 200,
        },
        {
          title: "结束物流码",
          key: "endSerial",
          width: 200,
        },
        {
          title: "数量",
          key: "number",
          width: 150,
        },
        {
          title: "时间",
          key: "codeTime",
          width: 200,
        },
        {
          title: "备注说明",
          key: "remark",
          minWidth: 400,
        },
        {
          title: "状态",
          key: "state",
          width: 100,
          slot: "stat",
          fixed: "right",
        }
      ],
      // 源数据
      data: [],
      // 搜索后的数据
      inData: [],
      // 分页后的数据
      pageData: [],
      inDatas: {
        inCode: "",
        inName: "",
        inWrite: "",
        inDate: "",
      },
      pages: 1,
      allPage: 1,
    };
  },
  mounted() {
    this.getCodeLists();

    // 初始列表过滤10
    this.pageData = this.data.filter((p, key) => {
      if (key < this.pages * 10 && key >= this.pages * 10 - 10) {
        return p;
      }
    });

    this.allPage = this.data.length;
    // console.log(page);
  },
  components: {
    NewCode,
  },
  watch: {
    data(newVal, oldVal) {
      this.data = newVal;
    },

    // 搜索过滤
    selectVal(newVal, oldVal) {
      var data = this.data.filter((p) => {
        if (p.startSerial <= newVal) {
          return p;
        }
        if (p.InCode == newVal) {
          return p;
        }
      });
      this.pages = 1;
      this.allPage = data.length;
      let arr = data.filter((p, key) => {
        if (key < this.pages * 10 && key >= this.pages * 10 - 10) {
          return p;
        }
      });
      this.pageData = arr;
    },
  },
  created() {
    let control = this.$store.state.control;
    if (control !== '1') {
      this.columns = this.columns.filter((p, key) => {
        if (p.title !== "企业代码") {
          return p;
        }
      });
    }
  },
  methods: {
    inAddVal(index) {
      this.addVal = true;
    },
    getCodeOne(filename, stat, num, l, code) {
      getBatchCodefiles({
        filename,
        stat,
        num,
        l,
        code
      });
    },
    // 分页过滤
    page(i) {
      this.pages = i;
      var data = this.data.filter((p) => {
        return p.name.indexOf(this.selectVal) !== -1;
      });
      // this.pages = 1
      let arr = data.filter((p, key) => {
        if (key < this.pages * 10 && key >= this.pages * 10 - 10) {
          return p;
        }
      });
      this.pageData = arr;
    },
    getCodeLists() {
      GetCodeList({}).then((res) => {
        if (res.code == 402) {
          this.$Notice.error({ title: "没有权限！" });
        }
        this.data = res;

        this.pageData = res.filter((p, key) => {
          if (key < this.pages * 10 && key >= this.pages * 10 - 10) {
            return p;
          }
        });
        this.allPage = this.data.length;
      });
    },
  },
};
</script>
<style scoped >
.top {
  width: 100%;
  background: white;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.select {
  margin-left: 10px;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
